import { ELOQUENT } from 'config/constants';

/**
 * Search
 * @param {Object} data
 * @returns {Promise}
 */
export function searchView(data) {
    return ELOQUENT.SearchView.search(data);
}
